<template>
  <section id="businessLoyaltyCardNumber">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off">
        <div class="column">
          <h5>
          Easy as that.
          <br>Welcome to the Shaves family!
        </h5>
        <p>Now just ask one of our sales consultants to help you get your physical card and you're ready to go.</p>
        </div>

        <div class="welcomeRes">
          <div class="column">
            <div class="control">
              <label for="cardNumber">
                New loyalty card number
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-mask="'######'"
                v-model="cardNumber"
                id="cardNumber"
                class="input"
                type="tel"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>


          <div class="column typeOfBussiness">
            <label for="businessType">
              Which friendly sales consultant assisted you?
              <span>*</span>
            </label>
            <autocomplete
              v-validate="'required'"
              :source="consultantNames"
              results-display="name"
              @selected="setConsultant"
            >
            </autocomplete>


        </div>
        </div>



      </form>

      <div class="actions">
        <button :disabled='loading' @click="toBusinessthanks()" class="button is-danger ml-auto"><i v-if="loading" class="fa fa-spinner fa-spin"></i>Done</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import { mask } from "vue-the-mask";
import axios from "axios";
import Autocomplete from 'vuejs-auto-complete';
import alertify from "alertifyjs";
import * as Sentry from "@sentry/browser";
export default {
  name: "businessloyalty",
  directives: { mask },
  components: {
    CancelButton,
    Autocomplete,
  },
  data() {
    return {
      consultants: [],
      selectedConsultant: '',
      cardNumber: "",
      searchConsultant: '',
      loading: false,
      consultantNames: [
        // {id: 1, name: 'No One'},
        // {id: 2, name: 'John Doe'},
        // {id: 4, name: 'Mary Mo'},
        // {id: 4, name: 'Hennri Slow'}
        {id: 1, name: 'RAJAN  MOODLEY'},
        {id: 2, name: 'PHILEMON KHUZWAYO'},
        {id: 3, name: 'SABELO MKHWANAZI'},
        // {id: 4, name: 'JERRY'},
        {id: 5, name: 'LARNALLE NAICKER'},
        // {id: 6, name: 'GOODENOUGH'},
        // {id: 7, name: 'ELAINE'},
        // {id: 8, name: 'CEDERICK'},
        // {id: 9, name: 'PRINCESS'},
        {id: 10, name: 'DONNY PRAHALAD'},
        {id: 11, name: 'NELSON GOVENDER'},
        // {id: 12, name: 'CARLO'},
        {id: 13, name: 'NOMTHI GUMEDE'},
        // {id: 14, name: 'JAPHET'},
        // {id: 15, name: 'JUSTICE Z'},
        // {id: 16, name: 'LUNGISANI'},
        {id: 17, name: 'RAJEN NAIDOO'},
        // {id: 18, name: 'THOKAZANI'},
        // {id: 19, name: 'ISAAC N'},
        {id: 20, name: 'JABULANI NGCOBO'},
        {id: 21, name: 'ANTOINETTE MCKNIGHT'},
        // {id: 22, name: 'MEGAN'},
        // {id: 23, name: 'ASHLEY G'},
        // {id: 24, name: 'SANJAY'},
        {id: 25, name: 'SUNITHA SEWNATH'},
        // {id: 26, name: 'MALIPHATHWE'},
        // {id: 27, name: 'MICHAEL G'},
        // {id: 28, name: 'MUZI G'},
        {id: 29, name: 'JUNIOR (Siboniso) KHUMALO'},
        // {id: 30, name: 'ELECTION'},
        // {id: 31, name: 'INNOCENT G'},
        // {id: 32, name: 'MICHELLE'},
        {id: 33, name: 'LINDE (Lindelani) Shange'},
        // {id: 34, name: 'MINKY'},
        // {id: 35, name: 'TERENCE'},
        {id: 36, name: 'TREVOR NGCOBO'},
        {id: 37, name: 'ANDILE MADLALA'},
        // {id: 38, name: 'LAWRENCE'},
        // {id: 39, name: 'NISHA'},
        // {id: 40, name: 'THAMIE'},
        {id: 41, name: 'AVINASH SUKHDAO'},
        {id: 42, name: 'VERNON GOVENDER'},
        // {id: 43, name: 'NJABULO'},
        // {id: 44, name: 'DUMISANI'},
        // {id: 45, name: 'LUNGANI'},
        // {id: 46, name: 'JASON'},
        // {id: 47, name: 'ETHEL'},
        {id: 48, name: 'BABE MOODLEY'},
        // {id: 49, name: 'MUSA'},
        // {id: 50, name: 'SINDI'},
        // {id: 51, name: 'APOLLO'},
        {id: 52, name: 'SIYANDA GASA'},
        // {id: 53, name: 'THAMI'},
        // {id: 54, name: 'MICHAEL'},
        {id: 55, name: 'ASHNI BOODRAM'},
        // {id: 56, name: 'MAXWELL'},
        {id: 57, name: 'CLINTON ZUMA'},
        {id: 58, name: 'THOSH RAJCOOMAR'},
        {id: 59, name: 'XOLANI MTHEMBU'},
        // {id: 60, name: 'VUSI'},
        // {id: 61, name: 'EMMANUEL'},
        {id: 62, name: 'IAN SCORGIE'},
        // {id: 63, name: 'SIFISO M'},
        // {id: 64, name: 'SIHLE'},
        {id: 65, name: 'PRISCILLA MEEK'},
        // {id: 66, name: 'XOLANI'},
        // {id: 67, name: 'MUZI D'},
        {id: 68, name: 'SIFISO D'},
        {id: 69, name: 'MICHAEL LYNCH'},
        {id: 70, name: 'DENZIL NAIDOO'},
        {id: 71, name: 'SHAUN REDDY'},
        {id: 72, name: 'SHAUN REDDY'},
        {id: 73, name: 'ZWELIHLE BIYELA'},
        {id: 74, name: 'HOWARD SHAVE'},
        // {id: 75, name: 'MOETI'},
        // {id: 76, name: 'JUSTICE R'},
        {id: 77, name: 'ANALIZE KING'},
        {id: 78, name: 'INNOCENT NDOU'},
        // {id: 79, name: 'BRIAN M'},
        // {id: 80, name: 'DANNY'},
        // {id: 81, name: 'ASHLEY N'},
        // {id: 82, name: 'KABELO'},
        {id: 83, name: 'PENELOPE ZWANE'},
        // {id: 84, name: 'PAUL'},
        // {id: 85, name: 'MDUDUZI'},
        // {id: 86, name: 'MYRA'},
        // {id: 87, name: 'FRANS'},
        {id: 88, name: 'SHAUN ARUNACHELLAM'},
        {id: 89, name: 'BEAUTY MADYAKA'},
        // {id: 90, name: 'PETROS'},
        {id: 91, name: 'BRIAN PILLAY'},
        // {id: 92, name: 'THOMAS'},
        {id: 93, name: 'NOSISA MALULEKE'},
        {id: 94, name: 'MSOMI (Mbuyiselo)'},
        // {id: 95, name: 'CRAIG'},
        // {id: 96, name: 'BHEKIMADLA ZULU'},
        {id: 97, name: 'GOODNOUGH MAGWAZA'},
        // {id: 98, name: 'SIBONISIWE'},
        // {id: 99, name: 'FEZILE'},
        {id: 100, name: 'BHEKI D'},
        // {id: 101, name: 'LINDELANI'},
        // {id: 102, name: 'ERICK'},
        // {id: 103, name: 'WELLINGTON'},
        {id: 104, name: 'NISHANA BAJALALL'},
        // {id: 105, name: 'LYNDA H'},
        // {id: 106, name: 'AARON'},
        // {id: 107, name: 'NOMFUNDO'},
        // {id: 108, name: 'STANTON'},
        // {id: 109, name: 'JAMES'},
        // {id: 110, name: 'SUSAN'},
        // {id: 111, name: 'YENZIWE NGIDI'},
        {id: 112, name: 'SUMEETH RAMDEYAL'},
        {id: 113, name: 'NICHOLUS MADLALA'},
        {id: 114, name: 'GIDEON VAN DER MERWE'},
        {id: 115, name: 'QUENTIN NAICKER'},
        {id: 116, name: 'RUAN DE BEER'},
        {id: 117, name: 'EMMANUEL N'},
        // {id: 118, name: 'SNE GUMEDE'},
        {id: 119, name: 'GUGU HLOPHE'},
        // {id: 120, name: 'LINDELANI SHANGE'},
        // {id: 121, name: 'LINDANI MDAWO'},
        // {id: 122, name: 'LINDELIHLE MBOKAZI'},
        {id: 123, name: 'KEVIN MOODLEY'},
        // {id: 124, name: 'KYLE CHETTY'},
        {id: 125, name: 'DAWN VAN STRAATEN'},
        // {id: 126, name: 'NTHABISENG MORETLWE'},
        // {id: 127, name: 'MHLENGI KWEYAMA'},
        // {id: 128, name: 'THULANI ZWANE'},
        // {id: 129, name: 'LYLE BROPHY'},
        {id: 130, name: 'MARCELLE ROETS'},
        {id: 131, name: 'REENIE NAIDOO'},
        {id: 132, name: 'SAMUKELO NGCOBO'},
        {id: 133, name: 'MINENHLE SHOZI'},
        // {id: 134, name: 'VICTOR NXUMALO(THUBELIHLE)'},
        {id: 135, name: 'SANVEER BRIJLAL'},
        {id: 136, name: 'DENESHAN ARUMUGAM'},
        {id: 137, name: 'SUNIL MANGROO'},
        {id: 138, name: 'PHUMLANI RADEBE'},
        {id: 139, name: 'MTHOBISI MTOLO'},
        {id: 140, name: 'ZODWA DLAMINI'},
        {id: 141, name: 'SIMO GOBA'},
        // {id: 142, name: 'LUNGILE MTSHALI'},
        {id: 143, name: 'NONKULULEKO SOKHLA'},
        {id: 144, name: 'SIYANDA DUBAZANA'},
        {id: 145, name: 'CHRISTOPHER KHUMALO (Chris)'},
        {id: 146, name: 'SAMKE ZUMA'},
        {id: 147, name: 'WALTER MOLEFE'},
        {id: 148, name: 'DORAH ADELEYE'},
        {id: 149, name: 'SIMPHIWE BULOSE'},
      ]
    };
  },
  methods: {
    setConsultant(val){
      this.selectedConsultant = val.display
    },
    toBusinessthanks() {
      this.loading = true;

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
          if(this.selectedConsultant == ''){
            document.body.classList.add('invalidField')
          }
        } else {
          this.$gtag.event('assisting_consultant', {
            'event_category': 'engagement',
            'event_label': this.selectedConsultant,
            'value': ''
          });
          this.$store.commit("SAVE_BUSINESS_CARD_DETAILS", {
            cardNumber: this.cardNumber,
            consultant: this.selectedConsultant
          });
          axios
            .post(
              this.$store.state.apiBaseUrl + "/signup/business",
              this.$store.state.business
            )
            .then(response => {
              this.$gtag.event('business_signup_success', {
                'event_category': 'engagement',
                'event_label': 'Customer Successfully Registered',
                'value': ''
              });
              this.loading = false;
              console.log(response);
              this.$router.push("/businessthankyou");
            })
            .catch(error => {
              this.$gtag.event('business_signup_failure', {
                'event_category': 'engagement',
                'event_label': 'Error Registering Customer',
                'value': ''
              });
              this.loading = false;
              if(error.response){
                alertify.error(error.response.data.message);
                Sentry.captureException(error);
              } else {
                alertify.error("Looks like our system is currently down. Our support have been notified.");
                Sentry.captureException(error);
              }
            });
        }
      });
    }
  },
  mounted() {
    this.cardNumber = this.$store.state.business.cardinfo ? this.$store.state.business.cardinfo.cardNumber : ""
    this.selectedConsultant = this.$store.state.business.cardinfo ? this.$store.state.business.cardinfo.consultant : ""
  },
  watch: {
    selectedConsultant: function(){
      if(this.salesPerson != ''){
        document.body.classList.remove('invalidField')
      }
    }
  }
};
</script>
